import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  isSavingData:boolean
  constructor(private authservice: AuthService, private toastService: ToastrService) { }
  email:any
  ngOnInit() {
  }
  resetPassword(form: NgForm) {
    this.isSavingData=true
    this.authservice.forgotPassword(form.value).subscribe((res) => {
      if (!res["error"]) {
        this.toastService.success(' Password reset link sent to the '+form.value.email);
        form.reset();
      } else {
        this.toastService.error(res['errorMessage']);
      }
      this.isSavingData=false
    }, (error) => {
      this.toastService.error(error.message);
      this.isSavingData=false
    })
  }
}
